<script>
import { mapGetters } from 'vuex'
import NoChoice from '../State/NoChoice'
import { Helper } from '@/mixin/helper'
import VideoItem from '../VideoItem.vue'
import GridOptions from '../GridOptions.vue'

export default {
  components: {
    NoChoice,
    GridOptions,
    VideoItem,
  },
  mixins: [Helper],

  data() {
    return {
      allPlaylist: {},
      emptyPlaylist: [],
      arrKeyPlaylistIsPlay: [],
      uniqueVehicleIds: [],
      gridState: 'gridNine',
      refresh: false,
    }
  },
  computed: {
    playerFullscreen() {
      return this.$refs.videoPlayerFullscreen.player
    },
    fleetOpen() {
      return this.$store.state.video.fleetOpen
    },
    fleetClose() {
      return this.$store.state.video.fleetClose
    },
    ...mapGetters({
      isWhitelabel: 'identity/isWhitelabel',
      hasAccess: 'identity/hasAccess',
    }),
    ...mapGetters('video', ['vehicleStatusByVehicleId']),
    illustrationPath() {
      return !this.isWhitelabel()
        ? require(`@/assets/images/illustration/saas/search.svg`)
        : require(`@/assets/images/illustration/whitelabel/search.svg`)
    },
    gridClass() {
      const classMapping = {
        gridOne: 'one',
        gridFour: 'four',
        gridSix: 'six',
        gridEight: 'eight',
        gridNine: 'nine',
        gridSixteen: 'sixteen',
      }

      return classMapping[this.gridState]
    },
    gridActive() {
      const numGrid = {
        gridOne: 1,
        gridFour: 4,
        gridSix: 6,
        gridEight: 8,
        gridNine: 9,
        gridSixteen: 16,
      }
      return numGrid[this.gridState]
    },
  },
  watch: {
    '$store.state.video.playlist'(playlist, oldPlaylist) {
      const vehicleIds = playlist.map((x) => x.vehicleId)
      const unique = Array.from(new Set(vehicleIds))
      this.uniqueVehicleIds = unique
      this.refresh = true

      setTimeout(() => {
        if (playlist.length < oldPlaylist.length) {
          let arrRemovedPlaylist = []
          oldPlaylist.forEach((_playlist) => {
            if (!playlist.map((data) => data.id).includes(_playlist.id)) {
              arrRemovedPlaylist.push(_playlist.id)
            }
          })
          const arrFilteredRemoved = Object.keys(this.allPlaylist).filter((item) => {
            return arrRemovedPlaylist.some((k) => item.includes(k))
          })
          arrFilteredRemoved.forEach((playlistIndexId) => {
            if (!this.allPlaylist[playlistIndexId].isRemoved) {
              this.allPlaylist[playlistIndexId] = {
                ...this.allPlaylist[playlistIndexId],
                isRemoved: true,
              }
            }
          })
        } else {
          for (let i = 0; i < playlist.length; i++) {
            const row = playlist[i]
            const isOldPlaylist = oldPlaylist.map((playlist) => playlist.id).includes(row.id)
            if (!isOldPlaylist) {
              this.allPlaylist[this.getIndexPlaylist(row.id)] = {
                ...row,
                videoStatus: 'connecting',
                fullscreen: false,
                isRemoved: false,
              }
            }
          }
        }
        this.refresh = false
        const arrKeyIsPlay = Object.keys(this.allPlaylist).filter(
          (id) => !this.allPlaylist[id].isRemoved
        )
        this.arrKeyPlaylistIsPlay = arrKeyIsPlay
        this.$forceUpdate()
      }, 300)

      setTimeout(() => {
        for (let i = 0; i < playlist.length; i++) {
          const row = playlist[i]
          const isOldPlaylist = oldPlaylist.map((playlist) => playlist.id).includes(row.id)
          if (isOldPlaylist) continue
        }
        this.$forceUpdate()
      }, 2000)
    },
  },

  mounted() {
    for (let i = 0; i < this.$store.state.video.maxVideo; i++) this.emptyPlaylist.push(null)
    const self = this
    this.$root.$on('onGotoHistory', function (video) {
      self.goToHistory(video)
    })

    document.body.classList.toggle('mc-trackvideo-fullscreen')

    // eslint-disable-next-line no-unused-vars
    window.addEventListener('popstate', (event) => {
      if (document.body.classList.contains('mc-trackvideo-fullscreen--detail')) {
        document.body.classList.remove('mc-trackvideo-fullscreen--detail')
      }
    })

    // eslint-disable-next-line no-unused-vars
    document.addEventListener('fullscreenchange', (event) => {
      const isExitFullscreen = document.fullscreenElement === null

      if (isExitFullscreen) {
        if (document.body.classList.contains('mc-trackvideo-fullscreen--detail')) {
          Object.keys(this.allPlaylist).forEach((playlistId) => {
            if (this.allPlaylist[playlistId].fullscreen) {
              this.allPlaylist[playlistId].fullscreen = false
            }
          })
          document.body.classList.remove('mc-trackvideo-fullscreen--detail')
          this.$forceUpdate()
        }
      }
    })
  },

  methods: {
    getVehicleStatusByVehicleId(vehicleId) {
      return this.vehicleStatusByVehicleId(vehicleId)
    },

    /**
     *
     * @param playlistId id playlist contain vehicleId and channel, example 32145:0
     * @return indexPlaylist format {vehicleId}:{channel}:{index} example 32145:0:1
     */
    getIndexPlaylist(playlistId) {
      return playlistId + ':' + Object.keys(this.allPlaylist).length
    },
    getLastIndexPlaylist(playlistId) {
      return Object.keys(this.allPlaylist).findLast((plalylistIndexId) =>
        plalylistIndexId.includes(playlistId)
      )
    },
    handleClickGridNumber(grid, gridNumber) {
      this.gridState = grid
      this.$store.commit('video/setGridNumber', gridNumber)
    },

    /**
     *
     * @param playlistId format {vehicleId}:{channel}:{index}
     * @param key key in object playlist
     * @param value new value
     */
    setPlaylistValue(playlistId, key, value) {
      this.allPlaylist[playlistId][key] = value
    },

    goToHistory(video) {
      if (this.$store.state.video.fleetSelection.length) {
        const index = this.$store.state.video.fleetSelection.findIndex(
          (x) => x.vehicleId == video.vehicleId
        )
        this.closeVideo(index, video)
      }

      setTimeout(() => {
        this.$router.push({
          name: 'Video History 3',
          params: { vehicleId: video.vehicleId, entryPoint: 'Sidebar' },
        })
      }, 500)
    },
  },
}
</script>

<template>
  <div class="mc-map mc-trackvideo-content bg-white border">
    <div class="d-flex justify-content-between p-2 border-bottom">
      <strong>{{ $t('menuitems.trackVideo.title') }}</strong>
      <GridOptions :grid-state="gridState" :fullscreen="true" @clickGridNumber="handleClickGridNumber" />
    </div>
    <div class="mc-trackvideo-card" :class="`mc-trackvideo-card--${gridClass}`">
      <VideoItem
        v-for="(id, index) in Object.keys(allPlaylist)"
        v-show="
          !allPlaylist[id].isRemoved &&
          arrKeyPlaylistIsPlay.findIndex((_id) => _id === id) < gridActive
        "
        :key="id"
        :ref="`videoItem${allPlaylist[id].vehicleId}-${index}`"
        :index="index"
        :playlist-id="id"
        :playlist="allPlaylist[id]"
        :arr-key-playlist-is-play="arrKeyPlaylistIsPlay"
        :unique-vehicle-ids="uniqueVehicleIds"
        :grid-state="gridState"
        @setPlaylistValue="setPlaylistValue"
      />
      <NoChoice
        v-for="(val, index) in emptyPlaylist"
        v-show="index < gridActive - arrKeyPlaylistIsPlay.length"
        :key="index"
        :class="{ 'mc-trackvideo__main-playlist': index === 0 && !arrKeyPlaylistIsPlay.length }"
      />
    </div>
  </div>
</template>
